import { useShallow } from 'zustand/react/shallow'
import { type BrandInfo } from '../constants'
import { useStmBrandStore } from './use-stm-brand-store'

/**
 * 使用者擁有且未過期的品牌清單。useShallow 避免 filter 回傳新 array reference 導致無限 re-render。
 */
export const useActiveBrands = (): BrandInfo[] =>
  useStmBrandStore(useShallow(state =>
    state.brands.filter(brand => !state.expiredCampaignCodes.includes(brand.campaignCode)),
  ))
